<template>
  <!-- ESTE COMPONENTE ES PARA TODAS LAS TIENDAS SE ME OLVIDO CAMBIARLE NOMBRE DE CORTETIENDAMAYOREO A SOLO CORTETIENDA -->
  <div class="content-box">
    <div class="row corte-tienda-rows">
      <div class="col-md-6">
        <center>
          <select
            style="width: 85%;"
            v-model="selectedTienda"
            class="form-control form-control-sm rounded bright"
            @change="updateRoute"
          >
            <option
              v-for="tienda in tiendas"
              :value="tienda.codigo"
              :key="tienda.codigo"
            >{{ tienda.nombre }}</option>
          </select>
        </center>

        <div class="calendar">
          <div class="calendar-header">
            <button @click="changeMonth(-1)">&lt;</button>
            <h3 style="cursor: pointer;" @click="selectDate()">{{ currentMonthName }} {{ currentYear }}</h3>
            <button @click="changeMonth(1)">&gt;</button>
          </div>
          <div class="calendar-grid">
            <div class="day-name" v-for="day in dayNames" :key="day">{{ day }}</div>
            <div
              class="day"
              v-for="(day, index) in daysInMonth"
              :key="index"
              :class="{
                'disabled': !day,
                'is-today': isToday(day.day),
                'is-selected': isSelectedDay(day.day)
              }"
              @click="day && !isDisabled(day.day) && selectDay(day.day)"
            >
              <div class="day-content" :class="[
                getDayStateClass(day.fullDate),
                getDayBorderClass(day.fullDate)
              ]">
                {{ day.day }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="btn-group dropend">
          <button v-if="!hayCorteTienda || current.estado >= 'A'" class="btn btn-sm btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
            aria-expanded="false">
            <i class="fas fa-cogs"></i> Acciones
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <h6 class="dropdown-header">Opciones</h6>
            <button type="button" v-if="!hayCorteTienda" data-toggle="modal" @click="selectAction('apertura')" data-target="#loginVerifyModal" class="dropdown-item">
              <i class="fas fa-box-open mr-2"></i>Aperturar
            </button>
            <button type="button" v-if="hayCorteTienda && current.estado === 'A'" @click="cerrar()" class="dropdown-item">
              <i class="fas fa-box mr-2"></i>Cerrar
            </button>
            <button 
              type="button" 
              v-if="hayCorteTienda && current.estado === 'B' && listoParaFinalizar" 
              data-toggle="modal" data-target="#loginVerifyModal" 
              @click="selectAction('finalizar')"
              class="dropdown-item"
            >
              <i class="fas fa-check mr-2"></i>Finalizar
            </button>
            <button
              type="button" 
              v-if="hayCorteTienda && current.estado === 'C'" 
              data-toggle="modal" data-target="#loginVerifyModal" 
              @click="selectAction('auditar')" class="dropdown-item"
            >
              <i class="fas fa-list mr-2"></i>Auditar
            </button>
            <button v-if="hayCorteTienda && current.estado <= 'B'" type="button" data-toggle="modal" data-target="#modalOperacion" class="dropdown-item">
              <i class="fas fa-file mr-2"></i>Nueva operación
            </button>
            <button v-if="hayCorteTienda" type="button" data-toggle="modal" @click="verAnotaciones"  class="dropdown-item">
              <i class="fas fa-list mr-2"></i>Ver anotaciones
            </button>
            <button v-if="hayCorteTienda" type="button"  @click="showAnotacionModal = true" class="dropdown-item">
              <i class="fas fa-sticky-note mr-2"></i>Nueva anotación
            </button>
            <hr class="dropdown-divider">
            <button type="button" v-if="hayCorteTienda && current.estado >= 'A'" class="dropdown-item" @click="verLogs()">
              <i class="fas fa-history"></i>Ver Histórico
            </button>
          </div>
        </div>
        <div class="info-panel">
          <div class="col-md-12" v-if="!hayCorteTienda">
            <div class="alert" style="background-color: #ee705c;" role="alert">
              <h4 class="alert-heading" style="color: #3e3949;">Observaciones:</h4>
              <p class="text-dark font-weight-bold"></p>
              <h6 class="fas fa-info text-info" style="font-size: 12px;"></h6>
              <span style="color: #5b5170; font-size: 15px;">&nbsp;<b>La tienda {{selectedTiendaName}}({{selectedTienda}}) no tiene apertura el día {{selectedDate}}!</b></span>
              <br>&nbsp;
              <span class="text-dark" style="font-size: 14px; color: #3e3949;">
                Debe aperturar tienda para poder iniciar labores del día
              </span>
              <p class="mb-0"></p>
              <i class="fas fa-check-circle"
                style="font-size: 100px; position: absolute; right: 1px; top: 55px; transform: translateY(-50%); opacity: 0.1; filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3)); z-index: 0;"></i>
            </div>
          </div>
          <div class="col-md-12" v-else>
            <h5>
              Corte de tienda #{{ current.numero }}
              <span class="badge badge-blue mr-2" v-if="current.estado === 'B'">Cerrado</span>
              <span class="badge badge-success mr-2" v-if="current.estado === 'A'">Abierto</span>
              <span class="badge badge-dark mr-2" v-if="current.estado === 'C'">Finalizado</span>
              <span class="badge badge-danger mr-2" v-if="current.estado === 'D'">Auditado</span>
              <span class="badge badge-parpadeo ml-2" v-if="listoParaFinalizar">Listo para finalizar</span>
            </h5>
            <small>ID: {{ current.id }}</small><br>
            <small style="color: gray" class="font-weight-bold" v-if="current.estado === 'D'">
              Información del corte de tienda:
              <br>
              <div v-if="current.estado >= 'B' || current.usuario_cierra ">
                <i style="color: gray" class="fas fa-info-circle"></i>
                El corte de tienda ha sido cerrado por el usuario {{ current.usuario_cierra_obj.username }} el día {{ current.fecha_corte | moment("DD/MM/YYYY HH:MM") }}.
              </div>
              <div v-if="current.estado >= 'C' || current.usuario_finaliza ">
                <i style="color: gray" class="fas fa-info-circle"></i>
                El corte de tienda ha sido finalizado por el usuario {{ current.usuario_finaliza_obj.username }} el día {{ current.fecha_finaliza | moment("DD/MM/YYYY HH:MM") }}.
              </div>
              <div v-if="current.estado === 'D' || current.usuario_audita ">
                <i style="color: gray" class="fas fa-info-circle"></i>
                El corte de tienda ha sido auditado por el usuario {{ current.usuario_audita_obj.username }} el día {{ current.fecha_auditado | moment("DD/MM/YYYY HH:MM") }}.
              </div><br>
            </small>
            <div class="table-responsive">
              <table class="table" style="font-size: 12px;">
                <thead>
                  <tr>
                    <th class="text-left">Fecha de apertura</th>
                    <th class="text-left">Fecha Cierre</th>
                    <th class="text-left">Listo para finalizar</th>
                    <th class="text-left">Fecha Finalizado</th>
                    <th class="text-left">Fecha Auditado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left">{{ current.fecha_apertura | moment("DD/MM/YYYY HH:MM") }}</td>
                    <td class="text-left">{{ current.fecha_corte | moment("DD/MM/YYYY HH:MM") }}</td>
                    <td class="text-left" v-if="current.fecha_listo_finalizar">{{ current.fecha_listo_finalizar | moment("DD/MM/YYYY HH:MM") }}</td>
                    <td class="text-left" v-else></td>
                    <td class="text-left"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="seleccionarDia" tabindex="-1" aria-labelledby="seleccionarDiaLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="seleccionarDiaLabel">Seleccione la fecha que desea</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input class="form-control" type="date" v-model="fechaSeleccionada">
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="seleccionarFecha()"
              class="btn btn-primary"
            >
              Buscar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row corte-tienda-rows mt-3">
      <div class="col-md-12">
        <center>
          <h5>Cortes de caja</h5><br>
        </center>
        <div class="table-responsive">
          <table class="table">
            <caption>
              Estados:
              <div
                class="mr-1 status-pill green"
                data-title="Aperturado"
                data-toggle="tooltip"
              ></div>Aperturado
              <div
                class="ml-2 mr-1 status-pill yellow"
                data-title="Pendiente"
                data-toggle="tooltip"
              ></div>Pendiente
              <div
                class="ml-2 mr-1 status-pill blue"
                data-title="Corte"
                data-toggle="tooltip"
              ></div>Cerrado
              <div
                class="ml-2 mr-1 status-pill dark"
                data-title="Finalizado"
                data-toggle="tooltip"
              ></div>Finalizado
              <div
                class="ml-2 mr-1 status-pill red"
                data-title="Auditado"
                data-toggle="tooltip"
              ></div>Auditado
            </caption>
            <thead>
              <tr>
                <th class="text-center">Serie Caja</th>
                <th class="text-center"># Caja</th>
                <th class="text-center"># Corte</th>
                <th class="text-center">Cajero</th>
                <th class="text-center">Fecha Apertura</th>
                <th class="text-center">Fecha Cierre</th>
                <th class="text-center">Estado</th>
                <th colspan="2" class="text-center">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!hayCorteTienda || cortesCaja.length === 0">
                <td colspan="11" class="text-center">Aún no hay datos para mostrar...</td>
              </tr>
              <tr
                v-else
                v-for="corte in cortesCaja"
              >
                <td class="text-center">{{corte.serie_caja}}</td>
                <td class="text-center">{{corte.caja_obj.numero}}</td>
                <td class="text-center">{{corte.numero}}</td>
                <td class="text-center">{{corte.usuario_obj.username}}</td>
                <td class="text-center">{{corte.fecha_apertura | moment("DD/MM/YYYY HH:MM")}}</td>
                <td v-if="corte.fecha_cierre != null" class="text-center">{{corte.fecha_cierre | moment("DD/MM/YYYY HH:MM")}}</td>
                <td v-else class="text-center"></td>
                <td class="text-center">
                  <div
                    :class="{
                      'status-pill green':corte.estado === 'A',
                      'status-pill yellow':corte.estado === 'B',
                      'status-pill blue':corte.estado === 'C',
                      'status-pill dark': corte.estado === 'F',
                      'status-pill red': corte.estado === 'Z',
                    }"
                    :data-title="corte.estado_corte"
                    data-toggle="tooltip"
                  ></div>
                </td>
                <td class="text-center">
                  <button class="btn btn-sm btn-outline-secondary"
                    @click="verDetalleCorte(corte.id)"
                  >
                    <i class="fas fa-eye"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row corte-tienda-rows mt-3">
      <div class="col-md-12">
        <center>
          <h5>Resumen de Cajas</h5><br>
        </center>
        <div class="table-responsive">
          <table style="font-size: 10px;background-color: #EDF6F9;" class="table table-bordered">
            <thead>
              <tr >
                <th colspan="2" class="text-center">Datos de Caja</th>
                <th colspan="5" class="text-center">Formas de Pago</th>
                <th colspan="4" class="text-center">Notas de crédito</th>
                <th colspan="5" class="text-center">Ventas</th>
              </tr>
              <tr style="border-bottom: 2px solid #000 !important;">
                <th class="text-center"># Caja</th>
                <th class="text-center">Serie Caja</th>
                <th class="text-center">Efectivo</th>
                <th class="text-center">Tarjetas</th>
                <th class="text-center">Cheques</th>
                <th class="text-center">Depósitos</th>
                <th class="text-center">Cert</th>
                <th class="text-center">NC Emitidas</th>
                <th class="text-center">NC Aplicadas</th>
                <th class="text-center">NC Devoluciones</th>
                <th class="text-center">Dev de Efectivo</th>
                <th class="text-center">Contado</th>
                <th class="text-center">Cert(-)</th>
                <th class="text-center">Autoconsumos</th>
                <th class="text-center">Crédito</th>
                <th class="text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!hayCorteTienda || resumenesCajas.length === 0"><td colspan="16" class="text-center"> Aún no hay datos para mostrar...</td></tr>
              <tr
                v-else
                v-for="resumen in resumenesCajas"
              >
                <td class="text-center">{{resumen.CAJA_NUM}}</td>
                <td class="text-center">{{resumen.SERIE_CAJA}}</td>
                <td class="text-right">Q {{resumen.EFECTIVO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.TARJETA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.CHEQUE.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.DEPOSITO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.CERT.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.NC_EMITIDA.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.NC_APLICADA.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right" v-if="resumen.DEVOLUCIONES<0">Q {{(resumen.DEVOLUCIONES*-1).toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right" v-else>Q {{(resumen.DEVOLUCIONES).toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.DEVOLUCIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.VENTA_CONTADO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right" v-if="resumen.CERT>0">Q {{(resumen.CERT*-1).toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right" v-else>Q {{resumen.CERT.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.AUTOCONSUMOS.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.VENTA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.VENTA_BRUTA.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="border-top: 4px double red;font-weight: normal !important;">
                <td class="text-center" colspan="2">{{ totalResumenCajas.SERIE_CAJA }}</td>
                <td class="text-right">Q {{ totalResumenCajas.EFECTIVO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.TARJETA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.CHEQUE.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.DEPOSITO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.CERT.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.NC_EMITIDA.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.NC_APLICADA.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right" v-if="totalResumenCajas.DEVOLUCIONES<0">Q {{ (totalResumenCajas.DEVOLUCIONES*-1).toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right" v-else>Q {{ totalResumenCajas.DEVOLUCIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.DEVOLUCIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.VENTA_CONTADO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right" v-if="totalResumenCajas.CERT>0">Q {{ (totalResumenCajas.CERT*-1).toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right" v-else>Q {{ totalResumenCajas.CERT.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.AUTOCONSUMOS.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.VENTA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCajas.VENTA_BRUTA.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
              </tr>
            </tfoot>
          </table>
          <small>
            <p>
              <b>Nota:</b>
            </p>
            <p>
              <i style="color: gray" class="fas fa-info-circle"></i>
              Aparecen dos veces certificado de regalo debido a que solo se registra como forma de pago, pero no se ve reflejado como monto en la factura emitida ya que se aplica como un descuento sobre el saldo a cobrar.
            </p>
          </small>
        </div>
      </div>
    </div>
    <!-- Fin Resumen Cajas -->
    <!-- Resumen de Liquidaciones CREDITO RECOLECCION -->
    <div class="row corte-tienda-rows mt-3" v-if="resumenesLiquidaciones.length > 0">
      <div class="col-md-12">
        <center>
          <h5>Resumen de Reparto Recolección</h5><br>
        </center>
        <div class="table-responsive">
          <table style="font-size: 10px;background-color: #EDF6F9;" class="table table-bordered">
            <thead>
              <tr >
                <th colspan="2" class="text-center">Datos de Caja</th>
                <th colspan="5" class="text-center">Formas de Pago</th>
                <th colspan="2" class="text-center">Venta</th>
              </tr>
              <tr style="border-bottom: 2px solid #000 !important;">
                <th class="text-center"># Caja</th>
                <th class="text-center">Serie Caja</th>
                <th class="text-center">Efectivo</th>
                <th class="text-center">Tarjetas</th>
                <th class="text-center">Cheques</th>
                <th class="text-center">Cert</th>
                <th class="text-center">Depósitos</th>
                <th class="text-center">Devoluciones(NC)</th>
                <th class="text-center">Reparto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!hayCorteTienda || resumenesLiquidaciones.length === 0"><td colspan="9" class="text-center"> Aún no hay datos para mostrar...</td></tr>
              <tr
                v-else
                v-for="resumen in resumenesLiquidaciones"
              >
                <td class="text-center">{{resumen.CAJA_NUM}}</td>
                <td class="text-center">{{resumen.SERIE_CAJA}}</td>
                <td class="text-right">Q {{resumen.EFECTIVO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.TARJETA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.CHEQUE.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.CERT.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.DEPOSITO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.DEVOLUCIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.VENTA_LIQUIDACIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="border-top: 4px double red;font-weight: normal!important;">
                <td class="text-center" colspan="2">{{ totalResumenLiquidaciones.SERIE_CAJA }}</td>
                <td class="text-right">Q {{ totalResumenLiquidaciones.EFECTIVO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenLiquidaciones.TARJETA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenLiquidaciones.CHEQUE.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenLiquidaciones.CERT.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenLiquidaciones.DEPOSITO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenLiquidaciones.DEVOLUCIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenLiquidaciones.VENTA_LIQUIDACIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <!-- Fin Resumen Liquidaciones CREDITO RECOLECCION -->
    <!-- Resumen de Cortes -->
    <div class="row corte-tienda-rows mt-3">
      <div class="col-md-12">
        <center>
          <h5>Resumen de Cortes</h5><br>
        </center>
        <div class="table-responsive">
          <table style="font-size: 10px;background-color: #EDF6F9;" class="table table-bordered">
            <thead>
              <tr >
                <th colspan="2" class="text-center">Datos de Caja</th>
                <th colspan="8" class="text-center">Formas de Pago</th>
                <th colspan="1" class="text-center">Caja</th>
              </tr>
              <tr style="border-bottom: 2px solid #000 !important;">
                <th class="text-center"># Caja</th>
                <th class="text-center">Serie Caja</th>
                <th class="text-center">Efectivo</th>
                <th class="text-center">Tarjetas</th>
                <th class="text-center">Cheques</th>
                <th class="text-center">Cert</th>
                <th class="text-center">Depósitos</th>
                <th class="text-center">NC Ingresadas</th>
                <th class="text-center">Devefec</th>
                <th class="text-center">Dev de Efectivo</th>
                <th class="text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!hayCorteTienda || resumenesCortes.length === 0"><td colspan="11" class="text-center"> Aún no hay datos para mostrar...</td></tr>
              <tr
                v-else
                v-for="resumen in resumenesCortes"
              >
                <td class="text-center">{{resumen.CAJA_NUM}}</td>
                <td class="text-center">{{resumen.SERIE_CAJA}}</td>
                <td class="text-right">Q {{resumen.EFECTIVO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.TARJETA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.CHEQUE.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.CERT.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.DEPOSITO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.NC.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.DEVEFEC.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.DEVOLUCIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.VENTA_CONTADO.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="border-top: 4px double red;font-weight: normal !important;">
                <td class="text-center" colspan="2">{{ totalResumenCortes.SERIE_CAJA }}</td>
                <td class="text-right">Q {{ totalResumenCortes.EFECTIVO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCortes.TARJETA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCortes.CHEQUE.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCortes.CERT.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCortes.DEPOSITO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCortes.NC.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCortes.DEVEFEC.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCortes.DEVOLUCIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenCortes.VENTA_CONTADO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <!-- Fin Resumen Cortes -->
     <!-- Resumenes de Totales -->
    <div class="row corte-tienda-rows mt-3">
      <div class="col-md-12">
        <center>
          <h5>Resumen de Totales</h5><br>
        </center>
        <div class="table-responsive">
          <table style="font-size: 10px;background-color: #EDF6F9;" class="table table-bordered">
            <thead>
              <tr >
                <th colspan="1" class="text-center">Datos de caja</th>
                <th colspan="2" class="text-center">Totales</th>
                <th colspan="2" class="text-center">Diferencias</th>
              </tr>
              <tr style="border-bottom: 2px solid #000 !important;">
                <th class="text-center"># Caja</th>
                <th class="text-center">Total de Caja</th>
                <th class="text-center">Toal de sistema</th>
                <th class="text-center">Faltante</th>
                <th class="text-center">Sobrante</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!hayCorteTienda || resumenesConciliaciones.length === 0"><td colspan="5" class="text-center"> Aún no hay datos para mostrar...</td></tr>
              <tr
                v-else
                v-for="resumen in resumenesConciliaciones"
              >
                <td class="text-center">{{resumen.CAJA_NUM}}</td>
                <td class="text-right">Q {{resumen.TOTAL_CAJA.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td class="text-right">Q {{resumen.TOTAL_SISTEMA.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td 
                  :class="{
                    'text-right': resumen.FALTANTE === 0,
                    'text-right table-danger': resumen.FALTANTE>0,
                  }"
                >Q {{resumen.FALTANTE.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
                <td
                  :class="{
                    'text-right': resumen.SOBRANTE === 0,
                    'text-right table-success': resumen.SOBRANTE>0,
                  }"
                >Q {{resumen.SOBRANTE.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="border-top: 4px double red;font-weight: normal !important;">
                <td class="text-center">{{ totalResumenConciliaciones.SERIE_CAJA }}</td>
                <td class="text-right">Q {{ totalResumenConciliaciones.TOTAL_CAJA.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td class="text-right">Q {{ totalResumenConciliaciones.TOTAL_SISTEMA.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td 
                  :class="{
                    'text-right': totalResumenConciliaciones.FALTANTE === 0,
                    'text-right table-danger': totalResumenConciliaciones.FALTANTE>0,
                  }"
                >Q {{ totalResumenConciliaciones.FALTANTE.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td 
                  :class="{
                    'text-right': totalResumenConciliaciones.SOBRANTE === 0,
                    'text-right table-success': totalResumenConciliaciones.SOBRANTE>0,
                  }"
                >Q {{ totalResumenConciliaciones.SOBRANTE.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <!-- Fin Resumen Totales -->
    <!-- Detalles de operaciones por venta del día -->
    <div class="row corte-tienda-rows mt-3">
      <div class="col-md-12">
        <center>
          <h5>Detalles de operaciones por venta del día</h5>
        </center>
        <div class="row justify-content">
          <div class="col-md-3 col-sm-12 m-2" v-if="opcionesBanco.length>0">
            <div class="dropdown">
              <button class="btn btn-outline-secondary dropdown-toggle w-100 text-left" 
                type="button" 
                data-toggle="dropdown" 
                aria-haspopup="true" 
                aria-expanded="false">
                Seleccione el Banco
              </button>
              <div class="dropdown-menu p-2" aria-labelledby="dropdownMenuButton" style="width: 100%;">
                <div class="form-check" v-for="opcion in opcionesBanco" :key="opcion.id"> 
                  <input class="form-check-input" 
                    type="checkbox" 
                    :value="opcion.id" 
                    :id="opcion.id" 
                    v-model="filtroBancoSeleccionados">
                  <label class="form-check-label" :for="opcion.id">
                      {{ opcion.nombre }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 m-2" v-if="opcionesFormaPago.length>0">
            <div class="dropdown">
              <button class="btn btn-outline-secondary dropdown-toggle w-100 text-left" 
                type="button" 
                data-toggle="dropdown" 
                aria-haspopup="true" 
                aria-expanded="false">
                Seleccione las Formas de Pago
              </button>
              <div class="dropdown-menu p-2" aria-labelledby="dropdownMenuButton" style="width: 100%;">
                <div class="form-check" v-for="opcion in opcionesFormaPago" :key="opcion"> 
                  <input class="form-check-input" 
                    type="checkbox" 
                    :value="opcion" 
                    :id="opcion" 
                    v-model="filtroFormaPagoSeleccionados">
                  <label class="form-check-label" :for="opcion">
                      {{ opcion }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 m-2" v-if="opcionesTipoPago.length>0">
            <div class="dropdown">
              <button class="btn btn-outline-secondary dropdown-toggle w-100 text-left" 
                type="button" 
                data-toggle="dropdown" 
                aria-haspopup="true" 
                aria-expanded="false">
                Seleccione el Tipo de Pago
              </button>
              <div class="dropdown-menu p-2" aria-labelledby="dropdownMenuButton" style="width: 100%;">
                <div class="form-check" v-for="opcion in opcionesTipoPago" :key="opcion"> 
                  <input class="form-check-input" 
                    type="checkbox" 
                    :value="opcion" 
                    :id="opcion" 
                    v-model="filtroTipoPagoSeleccionados">
                  <label class="form-check-label" :for="opcion">
                      {{ opcion }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-sm-12 m-2" v-if="opcionesTipo.length>0">
            <div class="dropdown">
              <button class="btn btn-outline-secondary dropdown-toggle w-100 text-left" 
                type="button" 
                data-toggle="dropdown" 
                aria-haspopup="true" 
                aria-expanded="false">
                Seleccione el Tipo
              </button>
              <div class="dropdown-menu p-2" aria-labelledby="dropdownMenuButton" style="width: 100%;">
                <div class="form-check" v-for="opcion in opcionesTipo" :key="opcion"> 
                  <input class="form-check-input" 
                    type="checkbox" 
                    :value="opcion" 
                    :id="opcion" 
                    v-model="filtroTipoSeleccionados">
                  <label class="form-check-label" :for="opcion">
                      {{ tipoOperacion(opcion) }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 m-2">
            <div class="form-group">
              <input placeholder="Banco, cuenta, referencia y terminal..." class="form-control" type="text" v-model="searchText"></input>
            </div>
          </div>
        </div>
        <div class="table-responsive tableFixHead">
          <table style="font-size: 10px;background-color: #EDF6F9;" class="table table-bordered">
            <thead>
              <tr>
                <th>
                  Fecha de Operación
                </th>
                <th>
                  Fecha de Creación
                </th>
                <th>
                  Banco
                </th>
                <th class="">
                  Cuenta
                </th>
                <th class="">
                  Doc
                </th>
                <th class="">
                  Refer.
                </th>
                <th>
                  Cometario
                </th>
                <th class="text-center">
                  Tipo
                </th>
                <th class="text-center">
                  Tipo Pago
                </th>
                <th class="text-center">
                  Forma Pago.
                </th>
                <th class="text-center">
                  Terminal ID
                </th>
                <th class="text-left">
                  Total
                </th>
                <th class="text-center"
                  colspan="2"
                  v-if="hayCorteTienda && current.estado < 'C'"
                >Acción</th>
              </tr>
            </thead>
            <tbody style="max-height: 500px;">
              <tr v-if="!hayCorteTienda || detalles.length === 0"><td colspan="14" class="text-center">Aún no hay datos para mostrar...</td></tr>
              <tr v-else v-for="detalle in detallesFiltrados">
                <td>
                  {{ detalle.fecha_operacion | moment('DD/MM/YYYY HH:mm') }}
                </td>
                <td>
                  {{ detalle.fecha_creacion | moment('DD/MM/YYYY HH:mm') }}
                </td>
                <td v-if="detalle.banco">
                  {{ detalle.banco_obj.nombre }}
                </td>
                <td v-else></td>
                <td v-if="detalle.cuenta_bancaria">
                  {{ detalle.cuenta_bancaria_obj.id }}
                </td>
                <td v-else></td>
                <td v-if="detalle.documento">
                  <div class="btn-group">
                    <div class="dropleft">
                      <button class="btn btn-sm btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-cogs"></i>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" :href="detalle.documento" target="_blank">
                          <i class="fas fa-eye"></i> Ver documento
                        </a>
                        <button type="button" v-if="current.estado === 'B'" @click="selectDetalleDocumento(detalle)" class="dropdown-item">
                          <i class="fas fa-edit"></i> Editar documento
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
                <td v-else>
                  <button class="btn btn-sm btn-outline-secondary" @click="selectDetalleDocumento(detalle)">
                    <i class="fas fa-plus"></i>
                  </button>
                </td>
                <td>
                  {{ detalle.referencia }}
                </td>
                <td>
                  {{ detalle.comentario }}
                  <small v-if="detalle.forma_pago === 'CHEQUE' && detalle.es_prefechado">- Prefechado</small>
                </td>
                <td class="text-center">
                  {{ tipoOperacion(detalle.tipo) }}
                </td>
                <td class="text-center">
                  {{ detalle.tipo_pago }}
                </td>
                <td class="text-center">
                  {{ detalle.forma_pago }}
                </td>
                <td v-if="detalle.terminal">
                  {{ detalle.terminal_obj.terminal_id }}
                </td>
                <td v-else></td>
                <td class="text-left">
                  Q {{ detalle.total.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td class="text-center" v-if="hayCorteTienda && current.estado < 'C'">
                  <button type="button" 
                    class="btn btn-sm btn-outline-warning"
                    @click="operacionEditModal(detalle)" 
                  >
                    <i class="fas fa-edit"></i>
                  </button>
                </td>
                <td class="text-center" v-if="hayCorteTienda && current.estado < 'C'">
                  <button class="btn btn-sm btn-outline-danger"
                    @click="quitarDetalleCorteTienda(detalle)">
                    <i class="fas fa-minus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="border-top: 4px double red;font-weight: normal!important;">
                <td class="text-right" colspan="10">TOTAL</td>
                <td></td>
                <td class="text-right">Q {{ totalOperaciones.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}</td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <div class="row corte-tienda-rows mt-3">
      <div class="col-md-12">
        <center>
          <h5>Cuadro de Cuadre</h5>
        </center>
        <div class="table-responsive">
          <table style="font-size: 10px;background-color: #EDF6F9;" class="table table-bordered">
            <tbody v-if="!hayCorteTienda">
              <tr>
                <td colspan="7" class="text-center">Aún no hay datos para mostrar...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-left">
                  Detalles
                </td>
                <td class="text-left">
                  Operaciones
                </td>
                <td class="text-left">
                  Faltantes(+)
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-left">
                  Total Detalles
                </td>
              </tr>
              <tr>
                <td class="text-left">
                </td>
                <td class="text-left">
                  Q {{ operaciones.DETALLE.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td class="text-left">
                  Q {{ operaciones.FALTANTE.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left">
                  Q {{ operaciones.TOTAL_CON_FALTANTES.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
              </tr>
              <tr>
                <td class="text-left">
                  Venta
                </td>
                <td class="text-left">
                  Venta Bruta
                </td>
                <td class="text-left">
                  Notas de crédito(-)
                </td>
                <td class="text-left">
                  Venta al crédito(-)
                </td>
                <td class="text-left">
                  Autoconsumos(-)
                </td>
                <td class="text-left">
                  Devoluciones(-)
                </td>
                <td class="text-left">
                  Reparto Recolección(+)
                </td>
                <td class="text-left">
                  Total Venta
                </td>
              </tr>
              <tr>
                <td class="text-left">
                </td>
                <td class="text-left">
                  Q {{ totalResumenCajas.VENTA_BRUTA.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td class="text-left">
                  Q {{ totalesCaja.NC_EMITIDA.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td class="text-left">
                  Q {{ totalesCaja.VENTA_CREDITO.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td class="text-left">
                  Q {{ totalesCaja.AUTOCONSUMOS.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td class="text-left" v-if="hayCorteTienda && current.tienda === '02'">
                  Q {{ totalResumenCajas.DEVOLUCIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td v-else>
                  Q 0.0
                </td>
                <td class="text-left">
                  Q {{ totalResumenLiquidaciones.VENTA_LIQUIDACIONES.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
                <td class="text-left">
                  Q {{ totalVenta.toLocaleString('es-GT', { minimumFractionDigits: 2 }) }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="7" class="text-right">Diferencia (Total Detalles - Total Venta)</td>
                <td :class="{
                  'text-left table-success':resultadoCuadre > 0,
                  'text-left table-danger': resultadoCuadre < 0,
                  'text-left': resultadoCuadre === 0.0,
                  }"
                >
                  Q {{resultadoCuadre.toLocaleString('es-GT', { minimumFractionDigits: 2 })}}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <!-- Modal Seleccionar Actualizar Documento Detalle -->
    <div class="modal fade" id="subirDocumentoDetalleModal" tabindex="-1" aria-labelledby="subirDocumentoDetalleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="subirDocumentoDetalleModalLabel">Seleccione el documento a subir</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input class="form-control" type="file" id="documentoUpdate" ref="documentoUpdate" name="documentoUpdate" accept="application/pdf">
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="updateDocumentoDetalle()"
              class="btn btn-primary"
            >
              Subir
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin de Modal Seleccionar Actualizar Documento Detalle -->
    <LogsTableModalComponent
      v-if="hayCorteTienda"
      modulo="cxc"  
      path="cortes-tienda-logs"
      :params="{corte_tienda:getId}"
      ref="logs"
    ></LogsTableModalComponent>
    <LoginVerify @login="handleLogin"></LoginVerify>

    <NuevaOperacionComponent
      v-if="hayCorteTienda"
      :current=current
      :tienda=selectedTienda
      :currentFullDate=selectedDate
      :total-ventas=totalVenta
      :total-detalles=operaciones.TOTAL_CON_FALTANTES
      @refreshCorte="refreshData"
    >
    </NuevaOperacionComponent>
    <EditarOperacionComponent
      v-if="hayCorteTienda"
      :corte_tienda=current
      :tienda=selectedTienda
      :currentFullDate=selectedDate
      :total-ventas=totalVenta
      :total-detalles=operaciones.TOTAL_CON_FALTANTES
      ref="editarOperacionModal"
      @refreshCorte="refreshData"
    >
    </EditarOperacionComponent>
    <!-- Modal Nueva Anotacion -->
    <AnotacionComponent 
      v-if="hayCorteTienda"
      :is-visible="showAnotacionModal"
      @close="showAnotacionModal = false"
      :corte-tienda="current"
      :total-venta="totalVenta"
      :total-detalles="operaciones.TOTAL_CON_FALTANTES"
    ></AnotacionComponent>
    <!-- Fin Anotacion -->
    
    <!-- Lista Anotaciones -->
    <ListaAnotacionesComponent
      v-if="hayCorteTienda"
      :corte_tienda_id="current.id"
      ref="listaAnotaciones"
    ></ListaAnotacionesComponent>
    <!-- Fin Lista Anotaciones -->
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import LogsTableModalComponent from "@/components/commons/LogsTableModalComponent";
import AnotacionComponent from "@/components/cxc/corte_tienda/AnotacionComponent";
import ListaAnotacionesComponent from "@/components/cxc/corte_tienda/ListaAnotacionesComponent";
import LoginVerify from "@/components/commons/LoginVerify";
import NuevaOperacionComponent from "@/components/cxc/corte_tienda/NuevaOperacionComponent";
import EditarOperacionComponent from "@/components/cxc/corte_tienda/EditarOperacionComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    LogsTableModalComponent,AnotacionComponent,ListaAnotacionesComponent,LoginVerify,
    NuevaOperacionComponent,EditarOperacionComponent
  },
  data() {
    const today = new Date();
    return {
      current:null,
      resumenesCajas:[],
      resumenesLiquidaciones:[],
      resumenesCortes:[],
      resumenesConciliaciones:[],
      cortesCaja:[],
      detalles:[],
      estados:[],
      tiendas: [],
      showAnotacionModal:false,
      searchText: "",
      detalleSeleccionado:null,
      filtroFormaPagoSeleccionados:[],
      filtroTipoSeleccionados:[],
      filtroBancoSeleccionados:[],
      filtroTipoPagoSeleccionados:[],
      usuario:{
        username: null,
        password:null,
      },
      selectedTienda: "", 
      fechaSeleccionada: "",
      currentDay: today.getDate(),
      currentMonth: today.getMonth(),
      currentYear: today.getFullYear(),
      selectedDate: '',
      minDate: new Date(2019, 0, 1), 
      maxDate: today,
      dayNames: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    };
  },
  computed: {
    hayCorteTienda(){
      return this.current ? true : false;
    },
    fechaSeleccionadaFormatted() {
      const mes = String(this.currentMonth + 1).padStart(2, '0');
      const dia = String(this.currentDay).padStart(2, '0');
      const fecha = `${this.currentYear}-${mes}-${dia}`;
      return fecha;
    },
    currentMonthName() {
      return new Date(this.currentYear, this.currentMonth).toLocaleString('es-ES', { month: 'long' });
    },
    daysInMonth() {
      const days = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
      const firstDayIndex = new Date(this.currentYear, this.currentMonth, 1).getDay();
      const emptyDays = Array(firstDayIndex).fill({ day: null, fullDate: null });
      const monthDays = Array.from({ length: days }, (_, i) => {
        const day = i + 1;
        const month = String(this.currentMonth + 1).padStart(2, '0');
        const formattedDay = String(day).padStart(2, '0');
        return {
          day: day,
          fullDate: `${this.currentYear}-${month}-${formattedDay}`
        };
      });
      return [...emptyDays, ...monthDays];
    },
    selectedDateFormatted() {
      if (!this.selectedDate) return 'Ninguna';
      const [day, month, year] = this.selectedDate.split('/');
      return `${day}/${month}/${year}`;
    },
    selectedTiendaName() {
      const tienda = this.tiendas.find(t => t.codigo === this.selectedTienda);
      return tienda ? tienda.nombre : '';
    },
    getId(){
      return this.hayCorteTienda ? this.current.id.toString().replace(/-/g, ""):"";
    },
    totalResumenCajas() {
      // 1. Define el objeto inicial para los totales.
      let totales = {
          SERIE_CAJA: "TOTAL",
          EFECTIVO: 0.0,
          TARJETA_CREDITO: 0.0,
          CHEQUE: 0.0,
          CERT: 0.0,
          DEPOSITO: 0.0,
          NC_EMITIDA: 0.0,
          NC_APLICADA: 0.0,
          DEVOLUCIONES: 0.0,
          VENTA_CONTADO: 0.0,
          VENTA_CREDITO: 0.0,
          AUTOCONSUMOS: 0.0,
          VENTA_BRUTA:0.0
      };
      if(!this.hayCorteTienda){ return totales;}
      // Array con los nombres de las claves numéricas que deseas sumar.
      // Usamos las claves que indicaste que devuelve tu lista.
      const camposASumar = Object.keys(totales).filter(key => key !== 'SERIE_CAJA');

      // 2. Iterar sobre los datos y acumular los totales.
      this.resumenesCajas.forEach(resumen => {
          camposASumar.forEach(campo => {
              
              // Clave: Usar parseFloat() y el operador OR (||) para:
              // 1. Convertir el valor a número, ya que puede venir como string.
              // 2. Usar 0 si el valor es null, undefined, o un string vacío.
              let valor = parseFloat(resumen[campo] || 0);

              // Solo suma si el valor es un número válido (previene NaN)
              if (!isNaN(valor)) {
                  totales[campo] += valor;
              }
          });
      });

      // 3. Formatear los resultados numéricos a dos decimales (opcional pero recomendado)
      camposASumar.forEach(campo => {
          // Convierte el total acumulado a un número de punto flotante fijo (ej: 123.45)
          totales[campo] = parseFloat(totales[campo].toFixed(2));
      });
      // 4. Se agrega la venta bruta al objeto totales.
      //totales.VENTA_BRUTA = totales.VENTA_CONTADO + totales.VENTA_CREDITO + totales.DEVOLUCIONES + totales.AUTOCONSUMOS;

      // 5. Retorna el objeto completo con los totales.
      return totales;
    },
    totalResumenCortes() {
      // 1. Define el objeto inicial para los totales.
      let totales = {
          SERIE_CAJA: "TOTAL",
          EFECTIVO: 0.0,
          TARJETA_CREDITO: 0.0,
          CHEQUE: 0.0,
          CERT: 0.0,
          DEPOSITO: 0.0,
          NC:0.0,
          DEVEFEC:0.0,
          NC_EMITIDA: 0.0,
          NC_APLICADA: 0.0,
          DEVOLUCIONES: 0.0,
          VENTA_CONTADO: 0.0,
          VENTA_CREDITO: 0.0,
          AUTOCONSUMOS: 0.0,
          VENTA_BRUTA:0.0
      };
      if(!this.hayCorteTienda){ return totales;}
      // Array con los nombres de las claves numéricas que deseas sumar.
      // Usamos las claves que indicaste que devuelve tu lista.
      const camposASumar = Object.keys(totales).filter(key => key !== 'SERIE_CAJA');

      // 2. Iterar sobre los datos y acumular los totales.
      this.resumenesCortes.forEach(resumen => {
          camposASumar.forEach(campo => {
              
              // Clave: Usar parseFloat() y el operador OR (||) para:
              // 1. Convertir el valor a número, ya que puede venir como string.
              // 2. Usar 0 si el valor es null, undefined, o un string vacío.
              let valor = parseFloat(resumen[campo] || 0);

              // Solo suma si el valor es un número válido (previene NaN)
              if (!isNaN(valor)) {
                  totales[campo] += valor;
              }
          });
      });

      // 3. Formatear los resultados numéricos a dos decimales (opcional pero recomendado)
      camposASumar.forEach(campo => {
          // Convierte el total acumulado a un número de punto flotante fijo (ej: 123.45)
          totales[campo] = parseFloat(totales[campo].toFixed(2));
      });
      // 4. Se agrega la venta bruta al objeto totales.
      //totales.VENTA_BRUTA = totales.VENTA_CONTADO + totales.VENTA_CREDITO + totales.DEVOLUCIONES + totales.AUTOCONSUMOS;

      // 5. Retorna el objeto completo con los totales.
      return totales;
    },
    totalResumenConciliaciones() {
      // 1. Define el objeto inicial para los totales.
      let totales = {
          SERIE_CAJA: "TOTAL",
          TOTAL_CAJA: 0.0,
          TOTAL_SISTEMA: 0.0,
          FALTANTE: 0.0,
          SOBRANTE: 0.0,
      };
      if(!this.hayCorteTienda){ return totales;}
      // Array con los nombres de las claves numéricas que deseas sumar.
      // Usamos las claves que indicaste que devuelve tu lista.
      const camposASumar = Object.keys(totales).filter(key => key !== 'SERIE_CAJA');

      // 2. Iterar sobre los datos y acumular los totales.
      this.resumenesConciliaciones.forEach(resumen => {
          camposASumar.forEach(campo => {
              
              // Clave: Usar parseFloat() y el operador OR (||) para:
              // 1. Convertir el valor a número, ya que puede venir como string.
              // 2. Usar 0 si el valor es null, undefined, o un string vacío.
              let valor = parseFloat(resumen[campo] || 0);

              // Solo suma si el valor es un número válido (previene NaN)
              if (!isNaN(valor)) {
                  totales[campo] += valor;
              }
          });
      });

      // 3. Formatear los resultados numéricos a dos decimales (opcional pero recomendado)
      camposASumar.forEach(campo => {
          // Convierte el total acumulado a un número de punto flotante fijo (ej: 123.45)
          totales[campo] = parseFloat(totales[campo].toFixed(2));
      });
      // 4. Se agrega la venta bruta al objeto totales.
      //totales.VENTA_BRUTA = totales.VENTA_CONTADO + totales.VENTA_CREDITO + totales.DEVOLUCIONES + totales.AUTOCONSUMOS;

      // 5. Retorna el objeto completo con los totales.
      return totales;
    },
    totalResumenLiquidaciones() {
      // 1. Define el objeto inicial para los totales.
      let totales = {
          SERIE_CAJA: "TOTAL",
          EFECTIVO: 0.0,
          TARJETA_CREDITO: 0.0,
          CHEQUE: 0.0,
          CERT: 0.0,
          DEPOSITO: 0.0,
          NC_EMITIDA: 0.0,
          NC_APLICADA: 0.0,
          DEVOLUCIONES: 0.0,
          VENTA_CONTADO: 0.0,
          VENTA_CREDITO: 0.0,
          VENTA_LIQUIDACIONES:0.0
      };
      if(!this.hayCorteTienda){ return totales;}
      // Array con los nombres de las claves numéricas que deseas sumar.
      // Usamos las claves que indicaste que devuelve tu lista.
      const camposASumar = Object.keys(totales).filter(key => key !== 'SERIE_CAJA');

      // 2. Iterar sobre los datos y acumular los totales.
      this.resumenesLiquidaciones.forEach(resumen => {
          camposASumar.forEach(campo => {
              
              // Clave: Usar parseFloat() y el operador OR (||) para:
              // 1. Convertir el valor a número, ya que puede venir como string.
              // 2. Usar 0 si el valor es null, undefined, o un string vacío.
              let valor = parseFloat(resumen[campo] || 0);

              // Solo suma si el valor es un número válido (previene NaN)
              if (!isNaN(valor)) {
                  totales[campo] += valor;
              }
          });
      });

      // 3. Formatear los resultados numéricos a dos decimales (opcional pero recomendado)
      camposASumar.forEach(campo => {
          // Convierte el total acumulado a un número de punto flotante fijo (ej: 123.45)
          totales[campo] = parseFloat(totales[campo].toFixed(2));
      });

      // 4. Retorna el objeto completo con los totales.
      return totales;
    },
    totalDetalles(){
      // 1. Define el objeto inicial para los totales.
      let totales = {
          total: 0.0,
      };
      if(!this.hayCorteTienda){ return totales;}
      // Array con los nombres de las claves numéricas que deseas sumar.
      // Usamos las claves que indicaste que devuelve tu lista.
      const camposASumar = Object.keys(totales).filter(key => key !== 'SERIE_CAJA');

      // 2. Iterar sobre los datos y acumular los totales.
      this.detalles.forEach(resumen => {
        let valor = parseFloat(resumen.total || 0);
        if (!isNaN(valor)) {
          totales['total'] += valor;
        }
      });

      // 3. Formatear los resultados numéricos a dos decimales (opcional pero recomendado)
      camposASumar.forEach(campo => {
          // Convierte el total acumulado a un número de punto flotante fijo (ej: 123.45)
          totales['total'] = parseFloat(totales['total'].toFixed(2));
      });

      // 4. Retorna el objeto completo con los totales.
      return totales;
    },
    totalVenta(){
      let self = this;
      let subtotal = 0.0;
      let total = 0.0;
      if(!this.hayCorteTienda){ return parseFloat(total);}
      let VENTA_BRUTA = self.totalResumenCajas.VENTA_BRUTA;
      let VENTA_CREDITO = self.totalResumenCajas.VENTA_CREDITO;
      let NOTA_CREDITO_EMITIDA = self.totalResumenCajas.NC_EMITIDA;
      let AUTOCONSUMOS = self.totalResumenCajas.AUTOCONSUMOS;
      let DEVOLUCIONES = self.current.tienda == '02'? self.totalResumenCajas.DEVOLUCIONES : 0.0;
      let LIQUIDACIONES = self.totalResumenLiquidaciones.VENTA_LIQUIDACIONES;
      // El total es igual o debe ser igual a la VENTA_CONTADO
      subtotal = VENTA_BRUTA - VENTA_CREDITO + NOTA_CREDITO_EMITIDA + DEVOLUCIONES - AUTOCONSUMOS + LIQUIDACIONES;
      total = subtotal.toFixed(2);
      return parseFloat(total);
    },
    totalesCaja(){
      let self = this;
      let VENTA_CREDITO = self.totalResumenCajas.VENTA_CREDITO > 0 ? self.totalResumenCajas.VENTA_CREDITO*-1 : self.totalResumenCajas.VENTA_CREDITO;
      let NC_EMITIDA = self.totalResumenCajas.NC_EMITIDA;
      let AUTOCONSUMOS = self.totalResumenCajas.AUTOCONSUMOS > 0 ? self.totalResumenCajas.AUTOCONSUMOS*-1 : self.totalResumenCajas.AUTOCONSUMOS;
      
      return {
        VENTA_CREDITO: VENTA_CREDITO,
        NC_EMITIDA: NC_EMITIDA,
        AUTOCONSUMOS: AUTOCONSUMOS,
      }
    },
    totalOperaciones(){
      let self = this;
      
      let total = 0.0;
      if(!this.hayCorteTienda){ return parseFloat(total);}
      total = self.detallesFiltrados.reduce((total, detalle) => {
        return total + parseFloat(detalle.total);
      },0.0)
      return total.toFixed(2);
    },
    operaciones(){
      let self = this;
      return {
        DETALLE: self.hayCorteTienda && self.current.total_detalle_operaciones > 0 ? self.current.total_detalle_operaciones : 0.0,
        FALTANTE: self.hayCorteTienda && self.current.total_detalle_faltantes > 0 ? self.current.total_detalle_faltantes : 0.0,
        TOTAL_CON_FALTANTES: self.hayCorteTienda && self.current.total_operacion_faltantes > 0 ? self.current.total_operacion_faltantes : 0.0,
        //TOTAL: self.hayCorteTienda && self.current.total_detalle > 0 ? self.current.total_detalle : 0.0,
      }
    },
    resultadoCuadre(){
      let self = this;
      return (self.operaciones.TOTAL_CON_FALTANTES - self.totalVenta).toFixed(2);
    },
    detallesFiltrados() {
      // Si el campo de búsqueda está vacío, muestra todas las facturas
      if (!this.hayCorteTienda){return this.detalles = [];}
      if (
        this.hayCorteTienda && 
        this.detalles.length > 0 && 
        !this.searchText && 
        this.filtroFormaPagoSeleccionados.length === 0 &&
        this.filtroTipoSeleccionados.length === 0 &&
        this.filtroTipoPagoSeleccionados.length === 0
      ) {
        return this.detalles;
      }
      const lowerCaseSearch = this.searchText?this.searchText.toLowerCase():"";
      return this.detalles.filter(detalle => {

        // Se definen los campos 
        let pasaFiltroCampos = true;
        let pasaFiltroFormaPago = true;
        let pasaFiltroTipo = true;
        let pasaFiltroBanco = true;
        let pasaFiltroTipoPago = true;
        
        //Convertir en String los campos a filtrar
        const bancoNombre = detalle.banco_obj ? String(detalle.banco_obj.nombre || "") : "";
        const cuentaBancaria = detalle.cuenta_bancaria_obj? String(detalle.cuenta_bancaria_obj.id || "") : "";
        const referencia = detalle.referencia ? String(detalle.referencia || "") : "";
        const terminal = detalle.terminal_obj ? String(detalle.terminal_obj.terminal_id || "") : "";
        const tipo_pago = detalle.tipo_pago ? String(detalle.tipo_pago || "") : "";
        
        // Convierte en minúsculas y realiza la búsqueda en el caso la cadena incluya alguno de los caracteres escritos en el campo de busqueda

        // Se verifica primero lo escrito
        pasaFiltroCampos = (
          bancoNombre.toLowerCase().includes(lowerCaseSearch) ||
          cuentaBancaria.toLowerCase().includes(lowerCaseSearch) ||
          referencia.toLowerCase().includes(lowerCaseSearch) ||
          terminal.toLowerCase().includes(lowerCaseSearch) ||
          tipo_pago.toLowerCase().includes(lowerCaseSearch)
        );
        
        pasaFiltroFormaPago = this.filtroFormaPagoSeleccionados.length === 0 || this.filtroFormaPagoSeleccionados.includes(detalle.forma_pago);

        pasaFiltroTipo = this.filtroTipoSeleccionados.length === 0 || this.filtroTipoSeleccionados.includes(detalle.tipo);

        pasaFiltroBanco = this.filtroBancoSeleccionados.length === 0 || this.filtroBancoSeleccionados.includes(detalle.banco);

        pasaFiltroTipoPago = this.filtroTipoPagoSeleccionados.length === 0 || this.filtroTipoPagoSeleccionados.includes(detalle.tipo_pago);

        return pasaFiltroCampos && pasaFiltroFormaPago && pasaFiltroTipo && pasaFiltroBanco && pasaFiltroTipoPago;
      });
    },
    opcionesFormaPago(){
      /* Mapear las formas de pago que hay en la lista */
      const formasPago = this.detalles.map(d => d.forma_pago);
      // Eliminar duplicados y ordenar alfabéticamente
      return [...new Set(formasPago)].sort();
    },
    opcionesTipo(){
      /* Mapear los tipos que hay en la lista */
      const tipos = this.detalles.map(d => d.tipo);
      // Eliminar duplicados y ordenar alfabéticamente
      return [...new Set(tipos)].sort();
    },
    opcionesTipoPago(){
      /* Mapear los tipos que hay en la lista */
      const tipos = this.detalles.map(d => d.tipo_pago);
      // Eliminar duplicados y ordenar alfabéticamente
      return [...new Set(tipos)].sort();
    },
    opcionesBanco() {
      const bancosUnicos = this.detalles.reduce((acc, detalle) => {
        const banco = detalle.banco_obj;

        // 1. Verificación de existencia: Solo procede si 'banco_obj' existe (no es null/undefined).
        if (banco) {
          // Usamos String() para ser explícitos en el tipo de la clave.
          const bancoId = String(banco.id); 

          // 2. Comprobar si el ID ya existe en el objeto acumulador.
          //    Si no existe, añadimos este objeto de banco.
          if (!acc[bancoId]) {
            acc[bancoId] = {
              id: bancoId,
              nombre: String(banco.nombre) // Garantizamos que es un string
            };
          }
        }
        return acc; // Devolvemos el objeto acumulador para la siguiente iteración
      }, {}); // El valor inicial del acumulador es un objeto vacío ({})

      // 3. Convertimos los valores del objeto acumulador de vuelta a un Array.
      const bancosArray = Object.values(bancosUnicos);

      // 4. Ordenamos por nombre para la visualización.
      return bancosArray.sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
    listoParaFinalizar(){
      let self = this;
      return self.hayCorteTienda && self.current.estado === 'B' && (self.resultadoCuadre >= -1) ? true : false;
    },
  },
  mounted() {
    this.refreshTiendas();
  },
  watch: {
    currentMonth: 'refreshEstadosPorDia',
    currentYear: 'refreshEstadosPorDia',
    selectedTienda: 'refreshEstadosPorDia',
    '$route'(to, from) {
      this.initializeFromRoute();
    },
  },
  methods: {
    initialize() {
      this.refreshTiendas();
    },
    initializeFromRoute() {
      const fecha = this.$route.query.fecha;
      const tienda = this.$route.query.tienda;

      if (!fecha || !tienda) {
        this.redirectToDefaults(fecha, tienda);
        return;
      }
      
      const tiendaURLEnLista = this.tiendas.find(t => t.codigo === tienda);
      if (!tiendaURLEnLista) {
          this.$toast.error("No tiene asignada la tienda especificada.","Error",{position: 'topRight'});
          this.redirectToDefaults(fecha, null);
          return;
      }

      if (fecha) {
        const [year, month, day] = fecha.split('-');
        const parsedYear = parseInt(year);
        const parsedMonth = parseInt(month) - 1;
        const parsedDay = parseInt(day);

        if (!isNaN(parsedYear) && !isNaN(parsedMonth) && !isNaN(parsedDay)) {
          this.currentMonth = parsedMonth;
          this.currentYear = parsedYear;
          this.currentDay = parsedDay;
          this.selectedDate = `${parsedDay}/${parsedMonth + 1}/${parsedYear}`;
        } else {
          this.redirectToDefaults(null, tienda);
          return;
        }
      }

      this.selectedTienda = tienda;
      this.refreshData();
    },

    redirectToDefaults(currentFecha, currentTienda) {
      let defaultFecha = currentFecha;
      let defaultTienda = currentTienda;

      if (!defaultFecha) {
        const today = new Date();
        const mes = String(today.getMonth() + 1).padStart(2, '0');
        const dia = String(today.getDate()).padStart(2, '0');
        defaultFecha = `${today.getFullYear()}-${mes}-${dia}`;
      }

      if (!defaultTienda) {
        if (this.tiendas.length > 0) {
          defaultTienda = this.tiendas[0].codigo;
        }
        else {
          defaultTienda = "02";
        }
      }
      this.$router.replace({
        name: 'cxc-corte-tienda',
        query: {
          fecha: defaultFecha,
          tienda: defaultTienda
        }
      });
    },
    refreshData(){
      let self = this;
      const fecha = this.fechaSeleccionadaFormatted;

      let params = {
        fecha: fecha,
        tienda: this.selectedTienda
      }
      DynamicService.postActionList("cxc","corte-caja-tienda","corte_por_fecha",params)
      .then(response =>{
        self.current = response.data;
        this.refreshCortesCaja();
        this.refreshDetalles();
        this.refreshResumen(this.fechaSeleccionadaFormatted);
      });
    },
    refreshTiendas(){
      let self = this;
      DynamicService.getActionList("cxc","corte-caja-tienda","lista_tiendas")
      .then(response =>{
        self.tiendas = response.data;
        const hayTiendas = self.tiendas.length > 0;
        const tiendaURL = self.$route.query.tienda;
        const tiendaURLEnLista = hayTiendas && tiendaURL ? self.tiendas.find(t => t.codigo === tiendaURL) : null;
        
        if(!hayTiendas){
          self.$toast.error("No está asignado a ninguna tienda.","Error",{position: 'topRight'});
          return;
        }

        if (tiendaURL && !tiendaURLEnLista) {
          this.$toast.error("No tiene asignada la tienda especificada.","Error",{position: 'topRight'});
          return;
        }

        self.initializeFromRoute();
      })
      .catch(error => {
        console.error(error);
        self.$toast.error(JSON.stringify(error.response.data),"Error",{position: 'topRight'});
      });
    },
    refreshEstadosPorDia(){
      let self = this;
      let params = {
        tienda: this.selectedTienda,
      }
      DynamicService.getActionList("cxc","corte-caja-tienda","estados_por_dia",params)
      .then(response =>{
        self.estados = response.data;
      });
    },
    refreshResumen(fecha){
      let self = this;
      if (!this.hayCorteTienda) {return;}
      let params = {
        fecha: fecha,
        tienda: this.selectedTienda
      }
      DynamicService.getActionList("cxc","corte-caja-tienda","generar_poliza_corte",params)
      .then(response =>{
        console.log(response.data);
        self.resumenesCajas = response.data.cajas;
        self.resumenesLiquidaciones = response.data.liquidaciones;
        self.resumenesCortes = response.data.cortes;
        self.resumenesConciliaciones = response.data.resumen_conciliacion;
      });
    },
    refreshCortesCaja(){
      let self = this;
      if (!this.hayCorteTienda) {return;}
      let params = {
        fecha: this.fechaSeleccionadaFormatted,
        tienda: this.selectedTienda,
      }
      DynamicService.postActionList("cxc","corte-caja-tienda","obtener_cortes_del_dia",params)
      .then(response => {
        self.cortesCaja = response.data;
      });
    },
    refreshDetalles(){
      let self = this;
      let id = this.getId;
      if (!this.hayCorteTienda) {return;}
      
      let params = {
        corte_tienda: id,
        quitar_paginacion: true,
      }

      DynamicService.fetch("cxc","cortes-tienda-detalles",params)
      .then(response => {
        self.detalles = response.data;
      })
      .catch(error => {
        self.detalles = [];
      });
    },

    operacionEditModal(operacion){
      //this.operacionSelected = null;
      // Llama al método showModal del componente hijo usando su ref
      this.$refs.editarOperacionModal.showModal(operacion);
    },
    // handleOperacionUpdated() {
    //   this.refreshCurrent(); 
    // },

    verDetalleCorte(id){
      let routeUrl = this.$router.resolve({
        name: "cxc-corte-caja-editar",
        params: { id: id },
      });
      window.open(routeUrl.href, "_blank");
    },

    tipoOperacion(tipo){
      if(tipo === "O"){
        return "Operación";
      }else if(tipo === "F"){
        return "Faltante";
      }else if(tipo === "S"){
        return "Sobrante";
      }
    },

    getDayStateClass(fullDate) {
      const dayState = this.estados.find(estado => estado.dia_corte === fullDate);
      if (dayState) {
        switch (dayState.estado) {
          case 'A': return 'state-A';
          case 'B': return 'state-B';
          case 'C': return 'state-C';
          default: return 'no-state';
        }
      }
      return 'no-state';
    },
    getDayBorderClass(fullDate) {
      const dayState = this.estados.find(estado => estado.dia_corte === fullDate);
      if (dayState && dayState.estado_tienda) {
        switch (dayState.estado_tienda) {
          case 'A': return 'border-A';
          case 'B': return 'border-B';
          case 'C': return 'border-C';
          case 'D': return 'border-D';
          default: return 'border-normal';
        }
      }
      return 'border-normal';
    },
    changeMonth(direction) {
      this.currentMonth += direction;
      if (this.currentMonth < 0) {
        this.currentMonth = 11;
        this.currentYear -= 1;
      } else if (this.currentMonth > 11) {
        this.currentMonth = 0;
        this.currentYear += 1;
      }
    },
    isToday(day) {
      const today = new Date();
      return (
        day === today.getDate() &&
        this.currentMonth === today.getMonth() &&
        this.currentYear === today.getFullYear()
      );
    },
    isDisabled(day) {
      if (!day) return true;
      const date = new Date(this.currentYear, this.currentMonth, day);
      return date < this.minDate || date > this.maxDate;
    },
    isSelectedDay(day) {
      return this.selectedDate === `${day}/${this.currentMonth + 1}/${this.currentYear}`;
    },
    selectDay(day) {
      this.selectedDate = `${day}/${this.currentMonth + 1}/${this.currentYear}`;
      this.currentDay = day;
      this.updateRoute();
    },
    selectDate() {
      $('#seleccionarDia').modal('show');
    },
    seleccionarFecha() {
      if (this.fechaSeleccionada === "") {
        alert("No se ha seleccionado ninguna fecha");
        return;
      }
      const [year, month, day] = this.fechaSeleccionada.split('-');
      this.currentMonth = parseInt(month) - 1;
      this.currentYear = parseInt(year);
      this.selectDay(parseInt(day));
      $('#seleccionarDia').modal('hide');
    },
    updateRoute() {
      const mes = String(this.currentMonth + 1).padStart(2, '0');
      const dia = String(this.currentDay).padStart(2, '0');
      const fecha = `${this.currentYear}-${mes}-${dia}`;

      this.$router.push({
        name: 'cxc-corte-tienda',
        query: {
          fecha: fecha,
          tienda: this.selectedTienda
        }
      });
    },
    verLogs(){
      this.$refs.logs.refreshLogs();
      $("#logModal").modal("show");
    },
    verAnotaciones(){
      $("#modalAnotaciones").modal("show");
      this.$refs.listaAnotaciones.refreshAnotaciones();
    },
    handleLogin(user) {
      this.user = user;
      if(this.action === 'apertura'){
        this.aperturar_tienda();
      }else if(this.action === 'finalizar'){
        this.finalizar();
      }else if(this.action === 'auditar'){
        this.auditar();
      }
    },
    selectAction(action){
      let self = this;
      self.action = null;
      self.action = action;
    },
    selectDetalleDocumento(detalle){
      let self = this;
      self.detalleSeleccionado = detalle;
      console.log(detalle)
      $("#subirDocumentoDetalleModal").modal("show");
    },
    updateDocumentoDetalle(detalle_id){
      let self = this;
      const formData = new FormData();
      if(!self.$refs.documentoUpdate.files[0]){
        self.$toast.error("No hay un documento seleccionado", "Error", { position: 'topRight' });
        return;
      }
      formData.append('documento', self.$refs.documentoUpdate.files[0]);
      DynamicService.postAction(
        "cxc",
        "cortes-tienda-detalles",
        self.detalleSeleccionado.id,
        'actualizar_documento',
        formData
      ).then((response) => {
        self.$refs.documentoUpdate.value = null;
        self.detalleSeleccionado = null;
        //self.limpiarOperacion();
        $("#subirDocumentoDetalleModal").modal("hide");
        self.$toast.success("Documento agregado con éxito", "Hecho", { position: 'topRight' });
        self.refreshData();
      })
      .catch((errors) => {
        if (errors.response) {
          console.error(errors.response.data);
          Notifications.alert.error(
            "Agregar documento",
            JSON.stringify(errors.response.data)
          );
        }
      });
    },
    quitarDetalleCorteTienda(detalle){
      let self = this;
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        self.current.id,
        'quitar_detalle_corte',
        {
          id: detalle.id,
          total_ventas:self.totalVenta,
          total_detalles:self.operaciones.TOTAL_CON_FALTANTES
        }
      ).then((response) => {
        self.$toast.success(JSON.stringify(response.data.detail), "Hecho", { position: 'topRight' });
        self.refreshData();
      })
      .catch((error) => {
        if(error.response){
          self.$toast.error(JSON.stringify(error.response.data), "Error", { position: 'topRight' });
        }
      });
    },
    aperturar_tienda(){
      let self = this;
      let params = {
        tienda: self.selectedTienda,
        usuario: self.user.username,
        clave: self.user.password,
        fecha: self.selectedDate,
      }
      DynamicService.postActionList(
        "cxc",
        "corte-caja-tienda",
        "aperturar_tienda",
        params
      )
       .then((response) => {
          Notifications.alert.success(
            "Corte de Tienda",
            response.data.detail
          );
          self.user.username = null;
          self.user.password = null;
          self.refreshData();
        })
       .catch((errors) => {
          if ('data' in errors.response) {
            Notifications.alert.error(
              "Corte de Tienda",
              JSON.stringify(errors.response.data)
            );
          }
        });
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas realizar el cierre de la tienda?",
        "Si Cerrar",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "cerrar"
          )
          .then((response) => {
            Notifications.alert.success(
              "Corte de Tienda",
              "Corte de Tienda Realizado con Éxito"
            );
            self.refreshData();
          }) 
          .catch((errors) => {
            console.error(errors)
            if ('data' in errors.response) {
              Notifications.alert.error(
                "Corte de Tienda",
                JSON.stringify(errors.response.data)
              );
            }
          });
        }
      );
    },
    finalizar() {
      let self = this;
      // Se manda los totales para no hacer un recalculo en el backend ahorrando un poco de tiempo en la petición, no es lo más aconsejable
      let params = {
        usuario: self.user.username,
        clave: self.user.password,
        total_ventas:self.totalVenta,
        total_detalles:self.operaciones.TOTAL_CON_FALTANTES
      }
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas finalizar el corte de la tienda?",
        "Si abrir",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "finalizar",
            params
          )
            .then((response) => {
              Notifications.alert.success(
                "Corte de Tienda",
                "Corte de Tienda Finalizado"
              );
              self.refreshData();
            })
            .catch((errors) => {
              if (errors.response) {
                Notifications.alert.error(
                  "Corte de Tienda",
                  JSON.stringify(errors.response.data)
                );
              }
            });
        }
      );
    },
    auditar(){
      let self = this;
      let params = {
        usuario: self.user.username,
        clave: self.user.password,
      }
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas auditar el corte de la tienda?",
        "Si",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "auditar",
            params
          )
          .then((response) => {
            Notifications.alert.success(
              "Corte de Tienda",
              "Corte de Tienda Auditado con éxito"
            );
            self.refreshData();
          })
          .catch((errors) => {
            if (errors.response) {
              console.error(JSON.stringify(errors.response.data));
              self.$toast.error(JSON.stringify(errors.response.data),"Error",{position: 'topRight'});
            }
          });
        })
    },
  }
};
</script>

<style scoped>
.corte-tienda-rows {
  background-color: #EAF6EA;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(15, 65, 19, 0.1);
}

.corte-tienda-rows:hover{
  background-color: #d9e7d9;
}

.calendar {
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000000;
  margin-top: 20px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  max-width: 600px;
  padding: 20px;
  background: rgba(75, 199, 102, 0.582);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(15, 65, 19, 0.1);
}

.calendar-header button {
  background: #385f32;
  color: #d7e1ec;
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  font-size: 1.2em;
  transition: background 0.3s;
}

.calendar-header h3:hover {
  color: #ffffff;
  transition: all 0.3s;
}

.calendar-header button:hover {
  background: #519e42;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  width: 90%;
  max-width: 600px;
  padding: 20px;
}

.day-name {
  font-weight: bold;
  text-align: center;
  color: #000000;
  text-transform: uppercase;
}

.day {
  text-align: center;
  padding: 0;
  background: none;
  border: 2px solid transparent; 
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: #2a7cda;
  transition: all 0.3s;
  overflow: hidden;
}

.day-content {
  padding: 6px;
  height: 100%;
  width: 100%;
  transition: background 0.3s, transform 0.2s, border 0.3s;
  border-radius: 8px;
  border: 2px solid #ccc; 
}

.day:hover .day-content {
  background: rgba(255, 255, 255, 0.5);
  transform: scale(1.1);
}

.day.is-today .day-content {
  border: 3px solid #e07228 !important;
  color: #e07228;
  font-weight: bold;
}

.day.is-selected .day-content {
  background: #e07228 !important;
  color: #fff;
  font-weight: bold;
}

.day.disabled {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(0, 0, 0, 0.3);
  cursor: not-allowed !important;
  border: 2px solid rgba(0, 0, 0, 0.2);
}

.info-panel {
  background: #EAF6EA;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(15, 65, 19, 0.1);
  border-radius: 10px;
  margin-top: 20px;
  border: 1px solid #dee2e6;
}

.info-panel h5 {
  color: #495057;
  margin-bottom: 15px;
}

.info-panel p {
  margin-bottom: 10px;
  color: #6c757d;
}

.info-panel:hover{
  transform: scale(1.03);
  transition: transform 0.3s;
}

@media (max-width: 768px) {
  .calendar-header {
    gap: 10px;
    padding: 10px;
  }

  .calendar-header h3 {
    font-size: 1.2em;
  }

  .calendar-header button {
    font-size: 1em;
    padding: 8px;
  }

  .calendar-grid {
    gap: 5px;
    padding: 10px;
  }

  .day {
    font-size: 0.8em;
  }

  .day-name {
    font-size: 0.9em;
  }
}

/* Clases para los estados de relleno */
.day-content.state-A {
  background-color: #5bbb36 !important;
}

.day-content.state-B {
  background-color: #d6b031 !important; 
}

.day-content.state-C {
  background-color: #1b6c9b !important;
}

.day-content.no-state {
  background-color: #f8f9fa !important;
  color: #2a7cda !important;
}

.day-content.state-A,
.day-content.state-B,
.day-content.state-C {
  color: #fff !important;
}

/* Clases para los estados de borde */
.day-content.border-A {
  border: 4px solid #71c21a !important;
}

.day-content.border-B {
  border: 4px solid rgb(4, 0, 240) !important;
}

.day-content.border-C {
  border: 4px solid #343a40 !important;
}

.day-content.border-D {
  border: 4px solid #c21a1a !important;
}

.day-content.border-normal {
  border: 4px solid #949393 !important;
}

@keyframes parpadear {
    0% {
      /* Estado inicial de la animación (color de fondo claro, texto oscuro) */
      background-color: #ffdda1; /* Naranja muy claro */
      color: #a0522d;            /* Marrón oscuro para el texto */
    }
    100% {
      /* Estado final de la animación (color de fondo intenso, texto blanco) */
      background-color: #ff9800; /* Naranja vibrante */
      color: #ffffff;            /* Blanco para el texto */
    }
  } 
  .badge-parpadeo {
    /* Define la animación: nombre, duración, repetición y dirección */
    animation: parpadear 1s infinite alternate; 
  }

</style>